/**
 * Created by sung on 2017-02-07.
 */
import {NgModule, Component, OnInit} from '@angular/core';

import {PickListModule, PanelModule,DataTableModule, ButtonModule, PaginatorModule,DropdownModule,InputTextModule, ListboxModule} from 'primeng/primeng';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import { MamAdminService } from '../../service/mam_service.component';
import { User } from '../../model/user';
import { AdminUser } from '../../model/admin_user';
import {SearchModule} from "../../component/search.component";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {SelectItem} from "primeng/components/common/api";
import {ExDialogModule} from "../../component/dialog.component";
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import { UserTitle } from '../../model/usertitle';
import { RoleType } from '../../model/enumModel';
import { IsUseType } from '../../model/enumModel';
import {CookieService} from "angular2-cookie/services/cookies.service";
import {Logger} from "angular2-logger/core"; // ADD THIS
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service";

enum DLG_Type {
  DLG_ADD,DLG_REMOVE,DLG_UPDATE
}


@Component({
  selector:'admin-management',
  templateUrl:'./admin_management.html'
})
export class AdminManagementComponent implements OnInit {

  // model
  private user_list : User[] = [];
  private admin_list : AdminUser[] = [];
  private company_list : ThirdPartyCompany[] = [];
  private non_set_company_list : ThirdPartyCompany[] = [];
  private targetCompanies : ThirdPartyCompany[] = [];
  private non_target_companis : ThirdPartyCompany[] = [];

  private user_title_list : UserTitle[] = [];
  selectedDetailUser: any;
  table_list: any;
  userInfo : User;
  selectCompany : ThirdPartyCompany;
  selectedTitle : UserTitle;
  passwordCheckResult : any;

  delTargets : any;

  login_admin : AdminUser;

  // select Items
  searchIDs: SelectItem[];
  selectCompanyItem : SelectItem[];
  selectedUserTitle : SelectItem[];
  roleType_item : SelectItem[];

  // boolean
  dateIsTrue : boolean;
  searchIsTrue : boolean;
  excelIsTrue : boolean = false;
  private dlg_disable:boolean = false;
  delete_use : boolean = false;

  // search
  sDate: string;
  eDate: string;
  searchText: string;
  searchId : string;
  pageMax:number =10;
  totalRecord: number;

  // dialog
  detailShow : boolean;
  addShow : boolean = false;
  title : string;
  addTitle : string;
  dialogWidth : any;
  addDialogWidth : number = 700;
  appointedTitle : string;
  appointeddialogWidth : 700;
  appointedShow : boolean = false;

  showIsUse : boolean = false;
  notUseType : any;

  //form
  addForm : FormGroup;

  username : string;
  private dlg_type:DLG_Type;

  select_UseType_items : SelectItem[];
  selectedUseType : IsUseType;
  selected_roleType : RoleType;
  translate : TranslateServiceForm;

  constructor(private service : MamAdminService, private fb:FormBuilder, private cookie: CookieService, private logger : Logger, private _translate : TranslateServiceForm) {
    this.translate = _translate;
    this.addTitle = this.translate.instant('LANG_ManagerAdd');
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_AdminName'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_AdminID'), value: 'username'});


    // this.roleType_item = [];
    // this.roleType_item.push({label : '---------------', value : ''});
    // this.roleType_item.push({label : '관리자', value : RoleType.ROLE_ADMIN});
    // // this.roleType_item.push({label : '보안관리자', value : RoleType.ROLE_SECURITY_MANAGER});
    // this.roleType_item.push({label : '슈퍼관리자', value : RoleType.ROLE_SUPER_MANAGER});
    // // this.roleType_item.push({label : '방문자관리자', value : RoleType.ROLE_VISITOR_ADMIN});
    // // this.roleType_item.push({label : '방문자매니저', value : RoleType.ROLE_VISITOR_MANAGER});

    this.select_UseType_items = [];
    this.select_UseType_items.push({label : '---------------', value : ''});
    this.select_UseType_items.push({label : this.translate.instant('LANG_Use'), value : IsUseType.USE });
    this.select_UseType_items.push({label : this.translate.instant('LANG_Not_Use'), value : IsUseType.NOT_USE});

    this.selectCompanyItem = [];
    this.selectCompanyItem.push({label : '---------------', value : ''});


    this.dateIsTrue = false;

    this.addForm = this.fb.group({
      'id' : new FormControl(''),
      'adminId' : new FormControl('',Validators.required),
      'name' : new FormControl('', Validators.required),
      'pass' : new FormControl('', Validators.required),
      'passwordConfirm' : new FormControl('', Validators.required),
      'roleType' : new FormControl('', Validators.required),
      'email' : new FormControl('', Validators.required),
      'company' : new FormControl('', Validators.required),
      'username' : new FormControl('', Validators.required),
      'isUse' : new FormControl('', Validators.required),
    });

  }

  ngOnInit() {
    this.getAdminList(0,10, '','');
    this.getCompanyList();


    this.AdminRoleCheck();
  }

  // SERVICE
  getCompanyList() {
    this.service.getCompanyAdminList().subscribe(
        value => {
          this.company_list = value;
          this.logger.debug("-- company_list :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {

          if(this.company_list.length > 0) {
            this.company_list.forEach(company => {
              this.selectCompanyItem.push({label:company.name, value:company});
            });
          }
        }
    )
  }


  // 검색
  getSearchModel(event){

    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;
    this.getAdminList(0,this.pageMax, this.searchText, this.searchId);

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getAdminList(event.page, event.rows, this.searchText, this.searchId);
    } else {
      this.getAdminList(event.page, event.rows, "", "");
    }

  }

  getAdminList(page:number, max:number, search:string, field:string) {
    this.service.getAdminList(page, max, search, field).subscribe(
        value => {
            this.admin_list = value.content;
            this.totalRecord = value.totalElements;
            this.logger.debug("-- admin_list :", value);
            console.log("-----------");
            console.log(value);
        },
        error => { this.logger.debug(error);},() => {}
    )
  }

  passwordChecker(password:string, user_data:any) {
    this.service.passwordChecker(password).subscribe(
        value => {
          this.passwordCheckResult = value;
          this.logger.debug("-- result :", this.passwordCheckResult);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          if(this.passwordCheckResult == 'OK'){
            if(this.admin_list.length <= 0) user_data.roleType = RoleType.ROLE_SUPER_MANAGER;

            this.notUseCheck(user_data.adminId);

            setTimeout(() => {

              if(this.dlg_type == DLG_Type.DLG_ADD && !this.notUseType) {
                this.logger.debug("--> create");
                user_data.id = null;
                user_data.username = user_data.adminId;
                this.insertAdmin(user_data);
              }
              // notuse 상태인 사용자를 다시 생성 했을 경우
              else if(this.dlg_type == DLG_Type.DLG_ADD && this.notUseType.isUse == "NOT_USE") {
                this.logger.debug("->update")
                this.updateAdmin(this.notUseType.id, user_data);
              }
              else if(this.dlg_type == DLG_Type.DLG_ADD && this.notUseType.isUse == "USE") {
                alert(this.translate.instant('MESSAGE_Duplicate_ID'));
                return;
              }
              // 수정할시.
              else if(this.dlg_type == DLG_Type.DLG_UPDATE) {
                this.updateAdmin(this.delTargets.id, user_data);
              }

              else {
                this.logger.debug("->이건머지..")
              }
            } , 200);
          } else {
            alert(this.passwordCheckResult);
          }
        }
    )
  }

  getUserTitle() {
    this.service.getUserTitle().subscribe(
        value => {
          this.user_title_list = value.rows;
          this.logger.debug("-- user_title_list :", this.user_title_list);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.selectedUserTitle = [];
          this.user_title_list.forEach(title => {
            this.selectedUserTitle.push({label: title.name, value: title});
          })
          this.selectedTitle = this.user_title_list[0];
        }
    )
  }

  insertAdmin(adminModel:any) {
    this.logger.debug("admin Model : ", adminModel);
    this.service.insertAdmin(adminModel.company.id, adminModel).subscribe(
        value => {
          let result = value;
          this.logger.debug("-- insert Admin User Result :", result);
          this.addShow = false;
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          this.insertUserTemp(adminModel);


        }
    )
  }
  insertUserTemp(user:any) {
      this.service.insertUserTemp(user).subscribe(
          value => {
            let result = value;
            this.logger.debug("result -> :", result);
          },
          error => {this.logger.error("-- error : " + error);},
          () => {
            this.notUseType = null;
            this.addForm.reset();
            this.getAdminList(0,10,'','');
          }
      )
  }

  updateAdmin(id:number, data:any) {
    this.logger.debug("admin update : ", data);
    this.logger.debug("admin update id : ", id);
    this.service.updateAdmin(id, data).subscribe(
        value => {},
        error => {this.logger.error("-- error : " + error);},
        () => {
          this.addShow = false;
          this.addForm.reset();
          this.notUseType = null;
          this.getAdminList(0,10, '', '');
        }
    )
  }

  addManageCompany(adminId:number, companyList:any) {
    this.service.addManageCompany(adminId, companyList).subscribe(
        value => {
          let result = value;
          this.logger.debug("addManageCompany :", value);
        },
        error => {this.logger.error("-- error : " + error);},
        () => {
             this.targetCompanies = [];
             this.non_target_companis = [];
             //getExcludeManageCompany
        }
    )
  }

  getManageCompany(adminId:number) {
    this.service.getManageCompany(adminId).subscribe(
        value => {
          this.targetCompanies = value;
        },
        error => {this.logger.error("-- error : " + error);},
        () => {
          this.appointedShow = true;
        }
    )
  }

  getExcludeManageCompany(adminId:number) {
    this.service.getExcludeManageCompany(adminId).subscribe(
        value => {
          this.non_target_companis = value;
          this.logger.debug("getExcludeManageCompany :", value);
        },
        error => {this.logger.error("-- error : " + error);},
        () => {
          this.appointedShow = true;
        }
    )
  }

  updateManageCompany(adminId:number) {
    this.service.updateManageCompany(adminId).subscribe(
        value => {},
        error => {this.logger.error("-- asdaserror : " + error);},
        () => {
          this.targetCompanies = [];
          this.non_target_companis = [];
        }
    )
  }


  removeAdmin(id:number) {
    this.service.removeAdmin(id).subscribe(
        value => {},
        error => {this.logger.error("-- error : " + error);},
        () => {
          this.getAdminList(0,10, '', '');
        }
    )
  }

  adminIdCheck(admin_id:string) {
    this.service.adminIdCheck(admin_id).subscribe(
        value => {
          if(value == false) {
            alert(this.translate.instant('MESSAGE_Duplicate_ID'));
            return;
          }
        },
        error => {this.logger.error("-- error : " + error);},
        () => {}
    )
  }

  AdminRoleCheck() {
    this.service.AdminRoleCheck().subscribe(
      value => {
        this.logger.debug("admin role check :", value);
        if(value == true) {
          this.roleType_item = [];
          this.roleType_item.push({label : '---------------', value : ''});
          this.roleType_item.push({label : this.translate.instant('manager'), value : RoleType.ROLE_ADMIN});
          // this.roleType_item.push({label : '보안관리자', value : RoleType.ROLE_SECURITY_MANAGER});
          this.roleType_item.push({label : this.translate.instant('RoleSuperManager'), value : RoleType.ROLE_SUPER_MANAGER});
          // this.roleType_item.push({label : '방문자관리자', value : RoleType.ROLE_VISITOR_ADMIN});
          // this.roleType_item.push({label : '방문자매니저', value : RoleType.ROLE_VISITOR_MANAGER});
        } else {
          this.roleType_item = [];
          this.roleType_item.push({label : '---------------', value : ''});
          this.roleType_item.push({label : this.translate.instant('manager'), value : RoleType.ROLE_ADMIN});
        }

      },
      error => {this.logger.error("-- error : " + error);},
      () => {}
    )
  }

  // 잠금해제
  unlockAction(data) {
    this.logger.debug("lock_release :", data);
    this.service.unlockAction(data.id).subscribe(
      value => {
        this.logger.debug("unlock : ", value)
      },
      error => {},
      () => {
        this.getAdminList(0,this.pageMax, this.searchText, this.searchId);
      }
    )
  }

  // 삭제된 admin 체크
  notUseCheck(data) {
    this.service.notUseCheck(data).subscribe(
      value => {
        this.logger.debug("notUseCheck : ", value)
        if(value) {
          this.notUseType = value;
        }

      },
      error => {},
      () => {
        //this.getAdminList(0,this.pageMax, this.searchText, this.searchId);
      }
    )
  }


  // EVENT
  appointed_confirm() {
    this.appointedShow = false;
    this.logger.debug(this.targetCompanies);
    let ids : number[] = []
    if(this.targetCompanies.length >0) {

      this.targetCompanies.forEach(value=>{
         ids.push(value.id);

      })
      this.logger.debug("ids -->", ids);
      this.addManageCompany(this.delTargets.id, ids);
    } else {
      this.updateManageCompany(this.delTargets.id);
    }
  }

  onMoveToTarget(event) {
    let tempCompanies : ThirdPartyCompany[] = [];
    try {
      event.items.forEach(value=> {
        this.non_target_companis.forEach(company =>{
          if(company.id != value.id) {
            tempCompanies.push(company);
          }
        })
      })
    } catch(e) {
      this.logger.debug(e.status);
    }
    this.non_target_companis = tempCompanies;
    this.logger.debug("onMoveTo Source after :", this.non_target_companis);

  }

  onMoveToSource(event) {
    let tempCompanies : ThirdPartyCompany[] = [];
    try {
      event.items.forEach(value=> {
        this.targetCompanies.forEach(company =>{
          if(company.id != value.id) {
            tempCompanies.push(company);
          }
        })
      })
    } catch(e) {
      this.logger.debug(e.status);
    }
    this.targetCompanies = tempCompanies;
    this.logger.debug("onMoveTo Source after :", this.targetCompanies);
  }

  onRowSelect(event){
    this.logger.debug("===> " ,this.delTargets);
    this.logger.debug(event.data);

    let admin = this.cookie.get('adminId');
    if(admin == event.data.adminId) this.delete_use = true;
    else this.delete_use = false;
  }

  add_admin() {
    this.addForm.reset();
    this.addShow = true;
    this.dlg_type = DLG_Type.DLG_ADD;
    this.addTitle = this.translate.instant('LANG_ManagerAdd');
    this.addForm.get('isUse').enable();
    this.addForm.get('username').enable();

  }

  private modi_admin(event) {
    this.dlg_type = DLG_Type.DLG_UPDATE;
    this.addTitle = this.translate.instant('LANG_ManagerEdit');
    if(!this.delTargets){
      alert(this.translate.instant('MESSAGE_Select_Administrator')); return;
    }

    this.logger.debug(this.delTargets);
    this.addForm.controls['name'].setValue(this.delTargets.name);
    //this.addForm.controls['roleType'].setValue(this.delTargets.roleType);
    this.addForm.controls['email'].setValue(this.delTargets.email);
    this.addForm.controls['company'].setValue(this.delTargets.company);
    this.addForm.controls['adminId'].setValue(this.delTargets.adminId);
    this.addForm.controls['username'].setValue(this.delTargets.adminId);
    this.addForm.controls['id'].setValue(this.delTargets.id);
    this.addForm.get('isUse').setValue(this.select_UseType_items[1].value);
    //this.addForm.controls['isUse'].setValue(this.delTargets.isUse);

    this.addForm.get('username').disable();
    if(this.delTargets.company) this.selectCompany = this.delTargets.company;
    this.selected_roleType = this.getRoleType(this.delTargets.roleType);
    this.selectedUseType = this.getIsUseType(this.delTargets.isUse);
    if(this.selected_roleType == RoleType.ROLE_SUPER_MANAGER) this.addForm.get('isUse').disable();
    this.addShow = true;
    this.dlg_disable = true;

  }

  getIsUseType(useType : string) : IsUseType {
    this.logger.debug("type :", useType);
    if(useType == 'USE') return IsUseType.USE;
    else return IsUseType.NOT_USE;
  }

  getRoleType(role:string) : RoleType {
    this.logger.debug("role =>" , role);
    if(role == "ROLE_SUPER_MANAGER") return RoleType.ROLE_SUPER_MANAGER;
    else return RoleType.ROLE_ADMIN;
  }

  private del_admin(event) {
    if(!this.delTargets) {
      alert(this.translate.instant('MESSAGE_Choose_Want_Delete'));
    } else {
      this.removeAdmin(this.delTargets.id);
    }
  }

  /*appoint_admin(event) {

    if(!this.delTargets) {
      alert("대상을 선택해 주세요");
      return;
    }
    this.getExcludeManageCompany(this.delTargets.id);
    this.getManageCompany(this.delTargets.id);
  }*/

  selectDetailUser(user){
    this.selectedDetailUser = user;
    this.logger.debug(user);
    this.detailShow = true;
    this.title = this.translate.instant('LANG_Detail');
    this.dialogWidth = 700;
  }

  confirm(event){
    this.detailShow = false;
  }


  cancel(event) {
    this.addShow = false;
    this.addForm.reset();


  }

  onChange(event) {
    this.logger.debug("event :", event);
    let companyId = event.value.id;
  }

  onChangeCompany(event) {
    this.logger.debug("onChageCompany :", event.value);
    this.selectCompany = event.value;
  }



  onChangeRoleType(event) {
    this.logger.debug("onChangeRoleType :", event.value);
  }

  onChangeUseType(event) {
    this.logger.debug("onChangeUseType :", event.value);
  }

  onSubmit(data) {
    this.logger.debug("title", data);
    if(data.pass == data.passwordConfirm) {
      this.passwordChecker(btoa(data.pass), data);
    } else {
      alert(this.translate.instant('MESSAGE_Password_Check_Again'));
    }
  }
   /*get diagnostic() { return JSON.stringify(this.addForm.value);}*/
  excelExport(event){
    this.logger.debug("excel 다운 : ",event);
    if(event){
      //엑셀 다운 진행.
    }
  }


}

@NgModule({
  imports:[ReactiveFormsModule, FormsModule, PanelModule,DataTableModule, ButtonModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule,SearchModule,ExDialogModule, ListboxModule, PickListModule, MainPipeMoudle, TranslatePipeMoudle],
  declarations:[AdminManagementComponent],
  exports:[AdminManagementComponent],
  providers:[MamAdminService]
})
export class AdminManagementModule{

}



// WEBPACK FOOTER //
// ./src/app/page/system/admin_management.ts